// extracted by mini-css-extract-plugin
export default {"fixedHeader":"Table_fixedHeader__DF2Vo","table":"Table_table__ilM5+","tdHidden":"Table_tdHidden__n-jnL"};